// src/axiosInstance.js
import axios from "axios";
// import dotenv from "dotenv";

// dotenv.config();

// console.log("API URL attuale:", process.env.VUE_APP_API_URL);

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
});

// Interceptor per debug degli errori
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error("Errore Axios:", error.response || error.message);
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
